import React from 'react';
import * as FontAwesome from 'react-icons/lib/fa';
import fcc from '../images/fcc_secondary_small.png';

class Contact extends React.Component {
	render(){
	return (
		<div className="contact">
			<h1>Follow Me:</h1>
			<div className="contactMe">
		      	<div className="social tweet">
		        	<a href="https://twitter.com/realbengummelt" target="_new"><FontAwesome.FaTwitter className="icon"/>
		          	<span>Twitter</span></a>
		      	</div>
		      	<div className="social linked">
		        	<a href="https://www.linkedin.com/in/benjamingummelt" target="_new"><FontAwesome.FaLinkedinSquare className="icon"/>
		          	<span>Linkedin</span></a>
		      	</div>
		      	<div className="social fcc">
		        	<a href="https://www.freecodecamp.org/camaromelt" target='_new'>
		          <img src={fcc} className="icon" alt="FreeCodeCamp Bio Link" /><span>FreeCodeCamp</span></a>
		      	</div>
			    <div className="social gplus">
			    	<a href="https://plus.google.com/+BenGummelt" target='_new'>
			          <FontAwesome.FaGooglePlusSquare className="icon"/><span>Google+</span></a>
			    </div>
			    <div className="social cp">
			    	<a href="https://codepen.io/camaromelt/" target='_new'>
			          <FontAwesome.FaCodepen className="icon"/><span>CodePen</span></a>
			    </div>
			    <div className="social git">
			    	<a href="https://github.com/camaromelt" target='_new'>
			          <FontAwesome.FaGithubSquare  className="icon"/><span>GitHub</span></a>
			    </div>
			</div>
		</div>
	)
	}
}

export default Contact;


/** WEBPACK FOOTER **
 ** ./src/components/Contact.js
 **/